export default ({ val }, context) => {
	return ({
		type: "logic",
		value: !val.value,
	});
};